import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';

const SessionEditor = ({ controlValue, setSession }) => {
  const normalize = (arr) => (arr || []).map(w => {
    const obj = Array.isArray(w) ? { start: String(w[0]||'00:00'), end: String(w[1]||'24:00') } : { start: String(w?.start||'00:00'), end: String(w?.end||'24:00') };
    // Display-friendly: HTML time input doesn't accept 24:00; show 23:59:59 but keep semantic midnight in backend conversion
    const toDisplay = (t) => (t === '24:00' || t === '24:00:00') ? '23:59:59' : t;
    return { start: toDisplay(obj.start), end: toDisplay(obj.end) };
  });
  const value = normalize(controlValue);
  const add = () => setSession([ ...value, { start: '09:00', end: '17:00' } ]);
  const update = (idx, key, v) => setSession(value.map((w,i)=> i===idx ? { ...w, [key]: v } : w));
  const remove = (idx) => setSession(value.filter((_,i)=>i!==idx));
  return (
    <div className="space-y-2">
      {value.map((w, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input type="time" step="1" value={w.start} onChange={(e)=>update(i,'start',e.target.value)} className="w-36" />
          <span className="text-sm">to</span>
          <Input type="time" step="1" value={w.end} onChange={(e)=>update(i,'end',e.target.value)} className="w-36" />
          <Button type="button" variant="destructive" size="sm" onClick={()=>remove(i)}>Remove</Button>
        </div>
      ))}
      <Button type="button" size="sm" variant="secondary" onClick={add}>Add Session</Button>
    </div>
  );
};

export default SessionEditor;
